function updateProductIds() {
    var checkedInputs = document.querySelectorAll('input[type="checkbox"]:checked');
    var updatedProductIds = Array.from(checkedInputs).map(input => input.getAttribute('data-product-id')).join(',');
    document.getElementById('productIds').textContent = updatedProductIds;
    
    var addToCartButton = document.querySelector('add-to-cart-button');
    addToCartButton.setAttribute('data-product-ids', updatedProductIds);
}
var checkboxes = document.querySelectorAll('input[type="checkbox"]');
checkboxes.forEach(function (checkbox) {
    checkbox.addEventListener('change', function () {
        updateProductIds();
    });
});
updateProductIds();